import { render, staticRenderFns } from "./LoginVerificationCard.vue?vue&type=template&id=a45dd6cc&scoped=true"
import script from "./LoginVerificationCard.vue?vue&type=script&lang=js"
export * from "./LoginVerificationCard.vue?vue&type=script&lang=js"
import style0 from "./LoginVerificationCard.vue?vue&type=style&index=0&id=a45dd6cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45dd6cc",
  null
  
)

export default component.exports